var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpdatedSolid = function SvgUpdatedSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.6 7.685h-.291c-2.466 0-3.699 0-4.006-.74-.271-.656.38-1.414 1.741-2.788a4.8 4.8 0 1 0 1.726 7.315 1.2 1.2 0 1 1 1.884 1.486 7.2 7.2 0 1 1-1.84-10.565C12.976 1.263 13.66.74 14.26.988 15 1.295 15 2.528 15 4.994v.291c0 1.132 0 1.697-.351 2.049-.352.351-.918.351-2.049.351Z",
    clipRule: "evenodd"
  })));
};
export default SvgUpdatedSolid;